// Deliberately small vocabulary: literal emphasis, never inferred classifications.
// Edit this shared map to configure terms and accessible ink/tint pairs.
export const REPORT_KEYWORDS = [
  { terms: ['moderate'], ink: '#795313', tint: '#fcf5e6' },
  { terms: ['low'], ink: '#254f7c', tint: '#edf3fa' },
  { terms: ['high'], ink: '#614577', tint: '#f4eff8' },
  { terms: ['strength', 'strengths', 'protective factor', 'protective factors'], ink: '#245e57', tint: '#edf6f3' },
  { terms: ['uncertainty', 'limitation', 'limitations', 'hypothetical'], ink: '#665345', tint: '#f6f2ed' },
  { terms: ['evidence'], ink: '#36577f', tint: '#f1f5fa' },
  { terms: ['recommendation', 'recommendations'], ink: '#614577', tint: '#f4eff8' },
];
export const reportKeywordStyle = (index) => {
  const colour = REPORT_KEYWORDS[index];
  return colour ? { '--report-keyword-ink': colour.ink, '--report-keyword-tint': colour.tint } : undefined;
};
const escapeRegex = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const terms = REPORT_KEYWORDS.flatMap((entry, index) => entry.terms.map(term => ({ term, index })));
const lookup = new Map(terms.map(({ term, index }) => [term.toLowerCase(), index]));
const pattern = new RegExp(`(?<![\\p{L}\\p{N}_])(?:${terms.map(x => x.term).sort((a, b) => b.length - a.length).map(escapeRegex).join('|')})(?![\\p{L}\\p{N}_])`, 'giu');

// Work only on parsed body text; preserve every original text node character.
// Inline emphasis may divide phrases, but headings, citations and blocks cannot.
export const highlightReportKeywords = (root, excluded) => {
  const doc = root.ownerDocument;
  let nodes = [];
  const flush = () => {
    let text = '';
    const entries = nodes.map(node => { const start = text.length; text += node.nodeValue; return { node, start, end: text.length }; });
    const citations = [...text.matchAll(/\[[^\]]*\]|【[^】]*】/g)].map(m => [m.index, m.index + m[0].length]);
    [...text.matchAll(pattern)].reverse().forEach(match => {
      const start = match.index; const end = start + match[0].length;
      if (citations.some(([a, b]) => start < b && end > a)) return;
      const index = lookup.get(match[0].toLowerCase());
      entries.filter(e => e.end > start && e.start < end).reverse().forEach(entry => {
        const selected = entry.node.splitText(Math.max(start, entry.start) - entry.start);
        selected.splitText(Math.min(end, entry.end) - Math.max(start, entry.start));
        const span = doc.createElement('span');
        span.className = 'report-keyword'; span.dataset.reportKeyword = index;
        Object.entries(reportKeywordStyle(index)).forEach(([key, value]) => span.style.setProperty(key, value));
        selected.replaceWith(span); span.append(selected);
      });
    });
    nodes = [];
  };
  const walk = node => {
    if (node.nodeType === 3) { nodes.push(node); return; }
    if (node.nodeType !== 1) return;
    if (node.matches(`${excluded},.report-keyword,.report-reference,a,sup,sub,.report-sentence-space,.report-sentence-continuation`)) { flush(); return; }
    const block = /^(P|DIV|LI|TD|TH|BLOCKQUOTE|UL|OL|TABLE|BR)$/.test(node.tagName) || node.matches('.report-field,.report-field-body');
    if (block) flush();
    Array.from(node.childNodes).forEach(walk);
    if (block) flush();
  };
  walk(root); flush();
};
